import { IRegEdSubmissionMetadata } from '@Queries/RegEdCompliance';
import * as Api from '@ViewModels';
import * as React from 'react';
import { BlogPostRequest } from '../../../models/Blogs';

export interface IBlogPostContext {
	blogPost?: Api.IBlogPost;
	request?: BlogPostRequest;
	sendFromUser?: Partial<Api.IUser>;
	// RegEd submission (format + answers) captured on the editor screen; consumed by ScheduleBlogPost
	// after the create so the submission can be attached to the server-created approval request.
	regEdMetadata?: IRegEdSubmissionMetadata;
	setBlogPost(blogPost: Api.IBlogPost): void;
	setRequest: (request: BlogPostRequest) => void;
	setSendFromUser: (user: Partial<Api.IUser>) => void;
	setRegEdMetadata: (metadata?: IRegEdSubmissionMetadata) => void;
}

export const BlogPostContext = React.createContext<IBlogPostContext>(null);

export const BlogPostContextProvider = ({ children }: { children: React.ReactNode }) => {
	const context = useCreatePostContext();

	return <BlogPostContext.Provider value={context}>{children}</BlogPostContext.Provider>;
};

export const useCreatePostContext = () => {
	const [context, setContext] = React.useState<IBlogPostContext>({
		blogPost: null,
		setBlogPost: (blogPost: Api.IBlogPost) => {
			setContext(prev => ({ ...prev, blogPost }));
		},
		request: null,
		setRequest: (request: BlogPostRequest) => {
			setContext(prev => ({ ...prev, request }));
		},
		sendFromUser: null,
		setSendFromUser: (user: Partial<Api.IUser>) => {
			setContext(prev => ({ ...prev, sendFromUser: user }));
		},
		regEdMetadata: undefined,
		setRegEdMetadata: (metadata?: IRegEdSubmissionMetadata) => {
			setContext(prev => ({ ...prev, regEdMetadata: metadata }));
		},
	});

	return context;
};
